/**
 * Created by madhanraj on 3/15/18.
 */

export const firebaseConfig = {
  apiKey: 'AIzaSyCfWtg7IYjMCJemQe955uztKQs4Cwiw580',
  authDomain: 'mj-portfolio-a9753.firebaseapp.com',
  databaseURL: 'https://mj-portfolio-a9753.firebaseio.com',
  projectId: "mj-portfolio-a9753",
  storageBucket: "mj-portfolio-a9753.appspot.com",
  messagingSenderId: "31536679738"
};



// WEBPACK FOOTER //
// ./src/environments/firebase.config.ts